var auth = require('./auth');
var constants = require('../config/constants');

var companiesService = {};

companiesService.fetchedCompanies = [];
companiesService.fetchInProgress = false;
companiesService.lastSearchParams = {};

companiesService.findCompanies = function(params) {
  return new Promise((resolve, reject) => {
    if (companiesService.fetchInProgress || (auth.currentUser() == null)) {
      reject(null);
    } else {
      companiesService.fetchInProgress = true;
      companiesService.lastSearchParams = params;
    var query = Object.keys(params)
    .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
    .join('&');

    var companiesUrl = constants.apiUrl + '/companies?' + query;
      auth.getToken().then(token => {
        fetch(companiesUrl, {
          headers: {
            'x-alueluettelo-auth': token
          }
        }).then(response => {
          response.json().then(json => {
            companiesService.fetchedCompanies = json;
            companiesService.fetchInProgress = false;
            resolve(json);
          });
        });
      });
    }
  });
}

companiesService.findUnpublishedCompanies = (total, unassignedOnly, industry) => {
  return new Promise((resolve, reject) => {
    var additionalParams = ''

    if (unassignedOnly) {
      additionalParams = '&seller=NO_SELLER'
    }

    if (industry) {
      additionalParams = additionalParams + '&industry=' + industry._id
    }

    const url = constants.apiUrl + '/companies?isPublished=false&to=' + total + additionalParams
    auth.getToken().then(token => {
      fetch(url, {
        headers: {
          'x-alueluettelo-auth': token
        }
      }).then(response => {
        response.json().then(companies => {
          resolve(companies)
        })
      })
    })
  })
}

companiesService.refreshSearchResult = () => {
  return companiesService.findCompanies(companiesService.lastSearchParams);
}

companiesService.createCompany = function(company) {
  return new Promise((resolve, reject) => {
    auth.getToken().then(token => {

      if  (!auth.userData.isAdmin) {
        company.seller = auth.userData._id;
      }

      fetch(constants.apiUrl + '/companies', {
        headers: {
          'x-alueluettelo-auth': token,
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(company)
      }).then(response => {
        response.json().then(json => {
          if (json.error) {
            reject(json.error);
          } else {
            if (!auth.userData.isAdmin) {
              companiesService.fetchedCompanies.companies.unshift(json);
              companiesService.fetchedCompanies.total += 1;
            }
            resolve(json);
          }
        });
      }).catch(error => reject(error));
    });
  });
}

companiesService.editCompany = function(company, decision) {
  return new Promise((resolve, reject) => {
    auth.getToken().then(token => {

      const toRet = {
        company: company
      };

      if (decision && decision._id) {
        toRet["newDecision"] = decision._id;
      }

      fetch(constants.apiUrl + '/companies', {
        headers: {
          'x-alueluettelo-auth': token,
          'Content-Type': 'application/json'
        },
        method: 'PUT',
        body: JSON.stringify(toRet)
      }).then(response => {
        response.json().then(json => {
          companiesService.refreshSearchResult().then(companies => resolve(json));
        });
      });
    }).catch(error => reject(error));
  });
}

companiesService.deleteCompany = function(companyId) {
  return new Promise((resolve, reject) => {
    auth.getToken().then(token => {
      fetch(constants.apiUrl + '/companies/' + companyId, {
        headers: {
          'x-alueluettelo-auth': token
        },
        method: 'DELETE'
      }).then(response => {
        companiesService.refreshSearchResult().then(companies => resolve());
      });
    }).catch(error => { reject(error) });
  });
}

companiesService.uploadLogo = function(companyId, logoData) {
  return new Promise((resolve, reject) => {
    auth.getToken().then(token => {
      fetch(constants.apiUrl + '/companies/' + companyId + '/logo', {
        headers: {
          'x-alueluettelo-auth': token
        },
        body: logoData,
        method: 'POST'
      }).then(response => {
        response.json().then(json => {
          if (json.error) {
            reject(json.error);
          } else {
            resolve(json.fileName);
          }
        });
      });
    }).catch(error => { reject(error) });;
  });
}

companiesService.deleteLogo = function(companyId) {
  return new Promise((resolve, reject) => {
    auth.getToken().then(token => {
      fetch(constants.apiUrl + '/companies/' + companyId + '/logo', {
        headers: {
          'x-alueluettelo-auth': token,
          'Content-Type': 'application/json'
        },
        method: 'DELETE',
      }).then(response => {
        response.json().then(json => {
          // categoriesService.refreshAllCategories().then(result => {
            resolve(true);
          // });
        });
      });
    }).catch(error => { reject(error) });
  });
}

companiesService.addContact = function(companyId, contact) {
  return new Promise((resolve, reject) => {
    auth.getToken().then(token => {
      fetch(constants.apiUrl + '/companies/' + companyId + '/contacts', {
        headers: {
          'x-alueluettelo-auth': token,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(contact),
        method: 'POST'
      }).then(response => {
        response.json().then(companyJson => {
          // categoriesService.refreshAllCategories().then(result => {
            resolve(companyJson);
          // });
        });
      });
    }).catch(error => { reject(error) });
  });
}


companiesService.deleteContact = function(companyId, contactId) {
  return new Promise((resolve, reject) => {
    auth.getToken().then(token => {
      fetch(constants.apiUrl + '/companies/' + companyId + '/contacts/' + contactId, {
        headers: {
          'x-alueluettelo-auth': token,
          'Content-Type': 'application/json'
        },
        method: 'DELETE'
      }).then(response => {
        response.json().then(companyJson => {
            resolve(companyJson);
        });
      });
    }).catch(error => { reject(error) });
  });
}

companiesService.assignSellerToCompanies = (seller, companies) => {
  return new Promise((resolve, reject) => {
    auth.getToken().then(token => {
      var bodyJson = {companyIds: companies};
      fetch(constants.apiUrl + '/companies/seller/' + seller._id, {
        headers: {
          'x-alueluettelo-auth': token,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(bodyJson),
        method: 'PUT'
      }).then(response => {
        resolve();
      });
    });
  });
}

module.exports = companiesService;



// WEBPACK FOOTER //
// ./src/service/companies.js